import { Routes } from '@angular/router';

import { AuthGuard } from '@celum/authentication';
import { CONFIGURATION_SERVICE, EDIT_MODE, ReadonlyConfigurationService } from '@celum/portals/shared';

import { PortalsAuthGuard } from './portals-auth.guard';

export const ROUTES: Routes = [
  {
    path: 'logout',
    loadComponent: () => import('@celum/authentication').then(mod => mod.LogoutComponent)
  },
  {
    path: 'logged-in',
    // AuthGuard will redirect to the final url after login
    canActivate: [AuthGuard],
    // Property is needed as a minimum to allow component-less routes
    children: []
  },
  {
    path: 'not-found',
    loadComponent: () => import('./page-not-found/page-not-found.component')
  },
  {
    path: ':id',
    canActivate: [PortalsAuthGuard],
    loadComponent: () => import('@celum/portals/features/portal').then(mod => mod.PortalComponent),
    providers: [
      { provide: CONFIGURATION_SERVICE, useClass: ReadonlyConfigurationService },
      { provide: EDIT_MODE, useValue: false }
    ]
  },
  {
    path: '',
    redirectTo: 'not-found',
    pathMatch: 'full'
  }
];
